'use client';

import { useEffect } from 'react';

type ClientCollectionSetupProps = {
  collectionType: string;
  roomType: string;
  roomStyle?: string;
  colors?: string[];
};

// Store collection info in localStorage as soon as possible so the
// virtual_page_view event and downstream consumers can read it.
export default function ClientCollectionSetup({
  collectionType,
  roomType,
  roomStyle = '',
  colors,
}: ClientCollectionSetupProps) {
  const filteredColors = colors?.filter(Boolean) ?? [];
  const colorsJson = filteredColors.length ? JSON.stringify(filteredColors) : '';

  useEffect(() => {
    const entries = [
      ['ds_collection_type', collectionType],
      ['ds_collection_roomtype', roomType],
      ['ds_collection_style', roomStyle],
      ['ds_collection_colors', colorsJson],
    ];

    for (const [key, value] of entries) {
      if (value) {
        localStorage.setItem(key, value);
      } else {
        localStorage.removeItem(key);
      }
    }

    return () => {
      for (const [key] of entries) {
        localStorage.removeItem(key);
      }
    };
  }, [collectionType, roomType, roomStyle, colorsJson]);

  return null;
}
